import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../../global-services/auth.service';
import { BaseBackendService } from 'app/global-services/base-backend.service';

class Auth0LinkedInUserDetailModel {
    exists: boolean;
    name: string | null;
    picture: string;
    email: string | null;
}

@Injectable()
export class DbcOnboardV2Service {

    constructor () {
    }

}

@Injectable()
export class DbcAuth0LinkedInUserDetailsService extends BaseBackendService<Auth0LinkedInUserDetailModel> {

    constructor (http: HttpClient, authService: AuthService) {
        super(http, authService, Auth0LinkedInUserDetailModel, 'dbc/auth0-linkedin-user', null);
    }

    getAuth0LinkedInUserDetails() {
        return this.http.get(this.apiURL, this.buildHeaders({}));
    }
}
